import styles from './Grouped.module.scss';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import React from 'react';

import { Body2 } from '../../../../../../typography/body2/Body2';
import { Caption } from '../../../../../../typography/caption/Caption';
import { TableRow } from '../../../../types';
import { RowIndent } from '../../../row-indent/RowIndent';
import { TableRow as TableRowComponent } from '../../../table-row/TableRow';

export const GROUP_ROW_MARKER = 'table-row-group-marker';

interface Props {
  row: TableRow;
  depth: number;
  cellClassName?: string;
}

export const Grouped: React.FC<Props> = (props) => {
  const { row, depth } = props;

  const { groupByID, groupByLabel, groupByTotalCount } = row;

  const cell = row.allCells.find((cell) => cell.column.id === groupByID);

  if (!cell) {
    console.error('cell not found');
    return null;
  }

  const attr = { [`data-${GROUP_ROW_MARKER}`]: true };
  return (
    <TableRowComponent isSelected={row.isSelected} isGrouped={true} {...attr}>
      <div
        style={{ display: 'flex', height: '100%', position: 'sticky', left: 0 }}
      >
        <RowIndent depth={depth} />

        <IconButton size="small" {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
        </IconButton>

        <Body2 className={styles.title}>
          {cell.column.Header}: {groupByLabel}
          <Caption className={styles.count}>({groupByTotalCount})</Caption>
        </Body2>
      </div>
    </TableRowComponent>
  );
};
